import createFetch from "@randajan/api-kit/client";
import createVault from "@randajan/vault-kit";


const fetchKurzy = createFetch({
    url:"https://data.kurzy.cz/json/meny/b[6].json",
    resultOnly:true
});

export const currencyRates = createVault({
    remote:{
        pull:_=>fetchKurzy()
    }
});



window.currencyRates = currencyRates;



//currencyRates.get().then(console.log);